import { useEffect } from "react";
import { useTranslation } from "src/hooks";
import { SingleSelection } from "../GeneralSelection";
import useQueryInvokerAddress from "./hooks/useQueryInvokerAddress";

function InvokerAddressSingleSelection({
  isSecondLayerToken,
  isSmartAccount,
  fieldName,
  chainType,
  chainId,
  currency,
  value,
  walletMajorVersion,
  tryDefaultWallet,
  onChange,
  onClear,
}: {
  isSecondLayerToken: boolean;
  isSmartAccount: boolean;
  fieldName: string;
  chainType: string;
  chainId: string;
  currency: string;
  value: string;
  walletMajorVersion?: number;
  tryDefaultWallet?: boolean;
  onChange: (value: string) => void;
  onClear?: () => void;
}) {
  const isNoShow = !isSecondLayerToken || isSmartAccount;

  const { tc } = useTranslation("common");
  const { invokerAddressSelectOptions, defaultAddress } =
    useQueryInvokerAddress({
      chainId,
      chainType,
      currency,
      enabled: !isNoShow,
      walletMajorVersion,
    });

  useEffect(() => {
    if (value || !defaultAddress || !tryDefaultWallet) {
      return;
    }

    onChange(defaultAddress);
  }, [defaultAddress, tryDefaultWallet, walletMajorVersion]);

  if (isNoShow) {
    return null;
  }

  return (
    <SingleSelection
      label={tc("phSelection", { fieldName })}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      enumData={invokerAddressSelectOptions}
      clearSelect={onClear || (() => {})}
      nameFn={(name) => name}
      sx={{ formControl: { minWidth: "15rem" } }}
    />
  );
}

export default InvokerAddressSingleSelection;
